/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, NgZone, Output, ChangeDetectionStrategy} from '@angular/core';
import {IS_TEST_ENVIRONMENT} from '../../../../shared/utils/is-test-environment';

@Component({
    selector: 'app-upload-configuration',
    templateUrl: './upload-configuration.component.html',
    styleUrls: ['./upload-configuration.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploadConfigurationComponent {
    @Input() baseDataCy = '';
    @Input() buttonText = '';
    @Input() disabled = false;
    @Output() loadEvent = new EventEmitter<string>();

    constructor(private ngZone: NgZone) {
        if (IS_TEST_ENVIRONMENT) {
            (window as any).UploadConfiguration = (files: FileList): void => this.ngZone.run(
                    () => this.onFileChange({
                        target: {
                            value: null,
                            files
                        }
                    } as any));
        }
    }

    get inputDataCy(): string {
        return `${this.baseDataCy}-input`;
    }

    get labelDataCy(): string {
        return `${this.baseDataCy}-label`;
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files == null || input.files.length !== 1) {
            throw new Error('You must upload exactly 1 file.');
        }

        const file = input.files[0];
        const reader: FileReader = new FileReader();

        reader.addEventListener('loadend', load => {
            const result = reader.result as string;
            this.loadEvent.emit(result);
        });

        reader.readAsText(file);

        input.value = '';
    }
}
